<template>
  <fts-design-modal
    full-screen
    class="fts-import-design-modal"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title with-hint" v-if="vector.name">
        <div class="design-modal-header-name import-design-header-name">Import for</div>
        <fts-moji
          :emoji="vector.emoji"
          class="design-modal-header-emoji"
          v-if="vector.emoji"
        />
        <div class="design-modal-header-name">{{vector.name}}</div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Basic</span>
      <span class="design-modal-header-description">
        import data
      </span>
    </template>
    <!-- body -->
    <template #body>
      <fts-import-designer
        :vector-id="vector.id"
        :states="states"
        :form-data="formData"
        @uploaded="fileUploaded"
        @import:success="importSuccess"
        @import:error="importError"
        ref="importDesigner"
      />
    </template>
    <!-- footer left -->
    <template #footerLeft>
      <!-- remove -->
      <fts-btn text icon @click="remove" v-if="isExist">
        <font-awesome-icon :icon="['far', 'trash-alt']" />
      </fts-btn>
      <!-- auth -->
      <fts-auth
        type="import"
        title="Import"
        preview-placement="top"
      >
        <fts-btn
          slot="trigger"
          slot-scope="{ show, isRight }"
          text
          icon
          :color="isRight ? 'danger' : 'default'"
          @click="show"
        >
          <font-awesome-icon :icon="['fas', 'lock']" v-if="isRight" />
          <font-awesome-icon :icon="['fas', 'unlock']" v-else />
        </fts-btn>
      </fts-auth>
    </template>
    <!-- footer right -->
    <template #footerRight>
      <!-- cancel -->
      <fts-btn text @click="beforeClose">Cancel</fts-btn>
      <!-- import -->
      <fts-btn
        text
        color="primary"
        @click="$refs.importDesigner.import()"
      >
        <font-awesome-icon :icon="['fas', 'file-upload']" /> Import
      </fts-btn>
      <!-- done -->
      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from "diff-json";

import FTSDesignModal from "./FTSDesignModal";
import FTSAuth from "./FTSAuth";
import FTSBtn from "../elements/FTSBtn";
import FTSMojiVue from '../elements/FTSMoji';
import FTSImportDesigner from "./FTSImportDesigner";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-auth": FTSAuth,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMojiVue,
    "fts-import-designer": FTSImportDesigner,
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
  }),
  methods: {
    async show(item) {
      this.formData = _.cloneDeep(item);

      if (!this.formData.script) {
        this.$set(this.formData, "script", "");
      }
      if (!this.formData.columns) {
        this.$set(this.formData, "columns", []);
      }

      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.reset();
            }
          },
        });
        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.reset();
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    remove() {
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: 'Delete import setting?',
        buttons: [
          { title: "Cancel" },
          {
            title: "Delete",
            default: true,
            handler: () => {
              this.$modal.hide("dialog");
              this.resolve && this.resolve(true);
              this.reset();
            },
          },
        ],
      });
    },
    reset() {
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    fileUploaded() {
      //
    },
    importSuccess() {
      //
    },
    importError() {
      //
    },
  },
  computed: {
    vector() {
      return this.$store.state.vector || {};
    },
    states() {
      return this.$store.getters.canvasStates;
    },
    isExist() {
      return Boolean(this.$store.getters.canvasImport);
    },
  }
}
</script>

<style lang="scss" scoped>
.fts-import-design-modal {
  .import-design-header-name {
    flex-shrink: 0;
    margin-right: .75rem;;
  }
}
</style>